// libs
import React, { useCallback, useEffect, useState, memo } from 'react';

// components
import { SHEET_TRANSITION, OverlaySheetContext } from 'shared/components/OverlaySheet';

// context
import { useLoaderContext } from 'shared/components/LoaderProvider/context';

// svg
import IconCross from 'shared/styles/assets/icons/components/IconCross';

// services
import { fetchEcomPolicyData as _fetchEcomPolicyData } from 'shared/store/details/services';

// styles
import { FixedContent, Wrapper, IconContainer, OverlaySheet } from './styles';

// def
import { IEcomPolicyData, IEcomPolicyKey } from 'shared/store/details/types';

// helpers
import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';
// constants
import { ROLES, TAB_INDEX } from 'shared/constants';

interface IEcomContentWrapperProps {
  productId: number;
  selectedItem: IEcomPolicyKey;
  showOverlaySheet: boolean;
  onOverlayHide: () => void;
  ecomPolicyData: IEcomPolicyData;
  fetchEcomPolicyData: typeof _fetchEcomPolicyData;
  isEComAPIError: boolean;
  isEComAPIFetching: boolean;
}

function EcomContentWrapper({
  productId,
  selectedItem,
  showOverlaySheet,
  onOverlayHide,
  ecomPolicyData,
  fetchEcomPolicyData,
  isEComAPIError,
  isEComAPIFetching,
}: IEcomContentWrapperProps) {
  const [data, setData] = useState('');
  const { showLoader, hideLoader } = useLoaderContext();

  const getData = useCallback(() => {
    // if there in redux return
    if (ecomPolicyData[selectedItem]) {
      setData(ecomPolicyData[selectedItem]);
      return;
    }

    // calling the api
    fetchEcomPolicyData(productId, selectedItem);
  }, [ecomPolicyData, fetchEcomPolicyData, productId, selectedItem]);

  useEffect(() => {
    if (productId && selectedItem) {
      getData();
    }
  }, [getData, productId, selectedItem]);

  const ecomPolicyHtml = data !== '' ? data : '';

  if (isEComAPIFetching) {
    showLoader({});
    return null;
  }

  hideLoader();

  if (!ecomPolicyHtml && !isEComAPIError) {
    return null;
  }

  if (!showOverlaySheet || !ecomPolicyHtml || (isEComAPIError && !ecomPolicyHtml)) {
    return null;
  }

  return (
    <OverlaySheet
      navKey={'ecom-policy-dweb'}
      onHide={onOverlayHide}
      transitionFrom={SHEET_TRANSITION.RIGHT}
      disableNav
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => {
          const onOverlayHideClick = () => {
            doHide();
          };
          return (
            <FixedContent>
              <Wrapper>
                <IconContainer
                  role={ROLES.BUTTON}
                  tabIndex={TAB_INDEX.ACTION_INVISIBILITY}
                  onClick={onOverlayHideClick}
                >
                  <IconCross />
                </IconContainer>
                <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(ecomPolicyHtml) }} />
              </Wrapper>
            </FixedContent>
          );
        }}
      </OverlaySheetContext.Consumer>
    </OverlaySheet>
  );
}
export default memo(EcomContentWrapper);
